module.exports = __webpack_public_path__ + "static/img/tab4.363c41f3.png";